import mapValues from 'lodash/mapValues';
import 'lodash/forEach';

const TypeDefType = {
  NATIVE: 0,
  ARRAY: 1,
  OBJECT: 2,
  SHAPE: 3
};
const ENTITY_DEFINED_LATER = "entity-defined-later";
function createExpectedTypedefError(receivedDefinition) {
  const error = new Error("Expected a typedef");
  error.data = {
    receivedDefinition
  };
  return error;
}
const identity = (v) => v;
const returnNull = () => null;
const deserializeString = (value) => `${value}`;
const deserializeNumber = (value) => Number.parseFloat(value);
const deserializeDate = (value) => new Date(value);
const deserializeBoolean = (value) => {
  if (typeof value === "string") {
    return value === "true" || !!Number.parseInt(value, 10);
  }
  return !!value;
};
function createShapeDeserializer(shapeDefinition) {
  return (object) => mapValues(
    shapeDefinition,
    (typeDefinition, prop) => typeDefinition.deserializer(object[prop])
  );
}
const shapeDefaultValueMapFunction = (typeDefinition) => typeDefinition.defaultValue;
function getShapeDefaultValue(shapeDefinition) {
  return mapValues(shapeDefinition, shapeDefaultValueMapFunction);
}
function compose(...functions) {
  return (argument) => {
    let previousValue = argument;
    for (const fn of functions) {
      previousValue = fn(previousValue);
    }
    return previousValue;
  };
}

export { ENTITY_DEFINED_LATER, TypeDefType, compose, createExpectedTypedefError, createShapeDeserializer, deserializeBoolean, deserializeDate, deserializeNumber, deserializeString, getShapeDefaultValue, identity, returnNull };
//# sourceMappingURL=utils.js.map
